import React from 'react';
import FeaturePage from './FeaturePage';

function RealTimeAnalyticsPage() {
  return (
    <FeaturePage title="Real-time Analytics">
      {/* You can add specific content here later */}
    </FeaturePage>
  );
}

export default RealTimeAnalyticsPage; 